import Role from '@/bundles/Roles/models/Role';

export default class RoleToMapper {
  mapToModel (data: any): Role {
    return new Role(data);
  }
}
